module.exports = __webpack_public_path__ + "img/searchTipTitle.fb1007f6.png";